import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.7979 3C14.8135 3 13.8917 3.48297 13.3313 4.29237L8.95276 10.617L14.133 15.7972L20.4576 11.4187C21.267 10.8583 21.75 9.93653 21.75 8.95209V4C21.75 3.44772 21.3023 3 20.75 3H15.7979Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.45708 10.2929C6.24523 10.0811 5.94957 9.97535 5.65143 10.0049C5.3533 10.0344 5.08411 10.196 4.91792 10.4453L4.68364 10.7967C3.99227 11.8338 4.01414 13.1903 4.73859 14.2045L5.94386 15.8919L3.74997 18.0858C2.96892 18.8668 2.96892 20.1332 3.74997 20.9142L3.83576 21C4.61681 21.7811 5.88314 21.7811 6.66418 21L8.85807 18.8061L10.5454 20.0114C11.5597 20.7358 12.9162 20.7577 13.9533 20.0663L14.3047 19.8321C14.5539 19.6659 14.7156 19.3967 14.7451 19.0985C14.7746 18.8004 14.6689 18.5047 14.4571 18.2929L6.45708 10.2929Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }